import { GrowthNotificationService } from './undergrad/pegasus-silver/growth-notification.service';

export default class GrowthNotification {
  static async notifyUser(email: string): Promise<void> {
    new GrowthNotificationService().notify(email);
  }
}
